import { find } from 'lodash';
function getConsentStatusDisplay(status, consentContactEnums) {
  var contactStatus = find(consentContactEnums, function (contactEnum) {
    return contactEnum.value === status;
  }) || {};
  switch (status) {
    case 'unsent':
      {
        return contactStatus.display_name;
      }
    case 'pending':
      {
        return "".concat(contactStatus.display_name, " Consent");
      }
    case 'accepted':
    case 'declined':
      return "Consent ".concat(contactStatus.display_name);
    default:
      {
        return 'No Consent';
      }
  }
}
export default getConsentStatusDisplay;
//# sourceMappingURL=getConsentStatusDisplay.js.map